import React from "react";
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSort } from '@fortawesome/pro-solid-svg-icons/faSort'
import { faSortDown } from '@fortawesome/pro-solid-svg-icons/faSortDown'
import { faSortUp } from '@fortawesome/pro-solid-svg-icons/faSortUp'

// Components
import Placeholder from "../Placeholder";
import LinkButton from '../LinkButton/LinkButton'
import ModalRoot from "../ModalRoot";
import ManageRateCardModal from "./ManageRateCardModal";
import FALabel from "../shared/FALabel";

// Redux
import { modals, rateCards as rateCardsDuck } from '../../ducks'
import { duckify, filterDuck } from "../../utils/duckify";
import { compose } from 'redux'
import { withRouter, Link } from "react-router";
import withFiltering from "../../hocs/withFiltering";
import withSorting from "../../hocs/withSorting";
import { sortInverse } from "../../utils/UriSorting";


const ManageRateCards = ({ allDucksReady, onSubmit, rateCards, showModal, sort, onSort }) => {

  return (
    <div className="manage-rate-cards">
      <ModalRoot modals={{ ManageRateCardModal }} />
      <h2>Manage Rate Cards</h2>
      <LinkButton
        className="add-item-button"
        content={<FALabel icon='plus-circle fa-fw' iconFirst label='Create a new rate card' />}
        onClick={() => showModal({ onSubmit })}
      />

      <Placeholder.loading ready={allDucksReady}>
        <table className="table table-striped rate-cards-list">
          <thead>
            <tr>
              <th className="'sortable">
                <Link to={onSort('name', ('name' === sort.column) ? sortInverse(sort.order) : 'desc')}>
                  Rate Card Name
                  <FontAwesomeIcon icon={(sort.column === 'name' && sort.order === 'asc' ? faSortUp : sort.column === 'name' && sort.order === 'desc' ? faSortDown : faSort)} />
                </Link>
              </th>
              <th>Domestic CC</th>
              <th>International CC</th>
              <th>ACH Rate</th>
              <th>NSF Rate</th>
              <th>Chargeback Rate</th>
              <th>Deprecated</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {
              rateCards.map(rateCard => {
                return (
                  <tr key={rateCard.id} data-group-id={rateCard.id}>
                    <td>{rateCard.name}</td>
                    <td>{rateCard.domestic_cc_percent}</td>
                    <td>{rateCard.intl_cc_percent}</td>
                    <td>{rateCard.ach_rate}</td>
                    <td>{rateCard.nsf_rate}</td>
                    <td>{rateCard.chargeback_rate}</td>
                    <td>{rateCard.deprecated && <i className="fa fa-check" />}</td>
                    <td>
                      <LinkButton
                        content='Edit'
                        onClick={() => showModal({ rateCard, onSubmit })}
                      />
                    </td>
                  </tr>
                )
              })
            }
          </tbody>
        </table>
      </Placeholder.loading>
    </div>
  )
}

ManageRateCards.propTypes = {
  rateCards: PropTypes.arrayOf(PropTypes.object),
  showModal: PropTypes.func,
  onSubmit: PropTypes.func,
}

ManageRateCards.defaultProps = {
  rateCards: [],
  onSubmit: () => false,
  showModal: () => false,
}

const mapDucksToProps = ({ filters, sortJson }) => ({
  rateCards: filterDuck(rateCardsDuck, { filters, sort: sortJson })
})

const mapDispatchToProps = (dispatch) => ({
  onSubmit: (rateCard, { setErrors }) => dispatch(rateCardsDuck.actions.save(rateCard))
    .then(() => dispatch(rateCardsDuck.actions.markDirty()))
    .then(() => dispatch(rateCardsDuck.actions.load()))
    .then(() => dispatch(modals.actions.hide()))
    .catch(err => {
      const { response, ...cleanErrors } = err
      setErrors(cleanErrors)
    }),
  showModal: props => dispatch(modals.actions.show('ManageRateCardModal', { ...props })
  )
})

export default compose(
  withRouter,
  withFiltering,
  withSorting({ column: 'name', order: 'asc' }),
  duckify(mapDucksToProps, () => ({}), mapDispatchToProps)
)(ManageRateCards)
